import { Component, OnInit } from '@angular/core';
import { NavParams, PopoverController } from '@ionic/angular';
import cloneDeep from 'lodash/cloneDeep';

@Component({
  selector: 'savedCreditCard-popover',
  templateUrl: 'savedCreditCardPopup.html',
  styleUrls: ['savedCreditCardPopup.scss'],

})

export class savedCreditCardPopup implements OnInit {

 
  public savedCards: any;
  


  constructor(public navParams: NavParams, private popoverController: PopoverController) {
  }

  ngOnInit() {

    this.savedCards = this.navParams.data.savedCards;
    
  }


  cardSelected(country) {
   
    this.popoverController.dismiss(country);
  }

}
